module.exports = __webpack_public_path__ + "img/g.e8ecad46.jpg";